/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { AsyncActionState, Constants, TimeUtils } from '@wit/vtv-x-foundation-lib';
import * as StreamWatchers from './streamWatchers';
import * as Sprites from './sprites';

export type Sprite = AsyncActionState<string | undefined>;

type ActiveStreamState = AsyncActionState<StreamWatchers.ActiveStream | undefined>;
type SpritesState = Array<Sprite>;

const activeStreamInitialState: ActiveStreamState = { data: undefined };
const spritesInitialState: SpritesState = [];

export function activeStream(state = activeStreamInitialState, action: StreamWatchers.Actions) {
  switch (action.type) {
    case StreamWatchers.ActionType.INIT:
      return {
        ...state,
        data: undefined,
        error: undefined,
        processed: false,
        processing: true,
      };
    case StreamWatchers.ActionType.SUCCESS:
      return {
        ...state,
        data: {
          asset: action.payload.asset,
          stream: action.payload.stream,
          url: action.payload.url,
          isRetry: action.payload.isRetry,
        },
        processed: true,
        processing: false,
      };
    case StreamWatchers.ActionType.FAIL:
      return {
        data: undefined,
        error: action.error,
        processed: true,
        processing: false,
      };
    case StreamWatchers.ActionType.CLEAR:
      return activeStreamInitialState;
    default:
      return state;
  }
}

export function sprites(state = spritesInitialState, action: Sprites.Actions | StreamWatchers.Actions) {
  switch (action.type) {
    case StreamWatchers.ActionType.SUCCESS: {
      const { asset } = action.payload;
      const spritesNumber = Math.ceil(TimeUtils.minutesToSeconds(asset.durationValue) / Constants.SECONDS_PER_SPRITE);

      return new Array<Sprite>(spritesNumber).fill({
        data: undefined,
        processing: false,
        processed: false,
        error: undefined,
      });
    }
    case StreamWatchers.ActionType.FAIL: {
      return spritesInitialState;
    }
    case Sprites.ActionType.INIT: {
      const spriteIndex = action.meta;
      const spritesCopy = [...state];

      spritesCopy[spriteIndex] = {
        ...spritesCopy[spriteIndex],
        processed: false,
        processing: true,
      };

      return spritesCopy;
    }
    case Sprites.ActionType.SUCCESS: {
      const spritesCopy = [...state];
      const { spriteIndex, url } = action.payload;

      spritesCopy[spriteIndex] = {
        ...spritesCopy[spriteIndex],
        data: url,
        processed: true,
        processing: false,
      };

      return spritesCopy;
    }
    default:
      return state;
  }
}
